import { selectActiveIndex, selectCurrentTab, selectIppicaTodayTablist } from 'features/ippica/selectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { IppicaWithTabTableHeaders } from './ippicaWithTabTableHeaders/IppicaWithTabTableHeaders';
import { IppicaWithTabTableCorseRenderer } from './ippicaWithTabTableCorseRenderer';
import { POLLING_INTERVAL_IPPICA } from 'features/ippica/constants';
import { SkeletonIppicaTabTable } from 'components/skeletonIppicaTabTable/SkeletonIppicaTabTable';
import classNames from 'classnames';
import { setIppicaTodayIndexActive } from 'features/ippica/ippicaSlice';
import styles from './IppicaWithTabTable.module.scss';
import { useEffect } from 'react';
import { useGetCorseDiOggiQuery } from 'features/api/ippicaApiSlice';
import useWindowSize from 'hooks/useWindowSize';

export const IppicaWithTabTable = () => {
  const { isMobile } = useWindowSize();

  const { isLoading, isError } = useGetCorseDiOggiQuery(`orderBy=Cronologico`, {
    refetchOnMountOrArgChange: true,
    pollingInterval: POLLING_INTERVAL_IPPICA,
  });
  const tabList = useTypedSelector(selectIppicaTodayTablist);

  const dispatch = useAppDispatch();
  const activeIndex = useTypedSelector(selectActiveIndex);
  const currentTimeIndex = useTypedSelector(selectCurrentTab);
  useEffect(() => {
    if (currentTimeIndex && currentTimeIndex !== -1) {
      dispatch(setIppicaTodayIndexActive(currentTimeIndex.toString()));
    } else {
      dispatch(setIppicaTodayIndexActive('0'));
    }
  }, [currentTimeIndex]);
  return isError ? null : isLoading || !tabList || !activeIndex ? (
    <SkeletonIppicaTabTable />
  ) : (
    <div className={styles.container}>
      <ul className={styles.tabsList}>
        {!!tabList?.length &&
          tabList.map((tab, index) => {
            return (
              <li key={tab + '_' + index} className={styles.tab}>
                <button
                  type="button"
                  className={`${styles.button} ${styles.noWrap} ${
                    activeIndex === index.toString() ? styles.active : ''
                  }`}
                  onClick={() => dispatch(setIppicaTodayIndexActive(index.toString()))}
                >
                  {tab}
                </button>
              </li>
            );
          })}
      </ul>
      <div className={classNames(styles.table, `${!tabList?.length ? styles.noBorder : ''}`)}>
        {!isMobile && <IppicaWithTabTableHeaders />}
        {<IppicaWithTabTableCorseRenderer />}
      </div>
    </div>
  );
};
